import React from 'react';
import './Home.css';
import blal from "../../assets/images/blal.png";
import pathlab from "../../assets/images/pathlab.png";
import precision from "../../assets/images/precision.png";
import goyal from "../../assets/images/goyal.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from "react-router-dom";


const images = [
    {
        id : 1,
        image : blal,
        link: "/drblal",
    },
    {
        id : 2,
        image : pathlab,
        link: "/drlalapath",
    },
    {
        id : 3,
        image : precision,
        link: "/drblal",
    },
       {
        id : 4,
        image : goyal,
        link: "/drblal",
    },
];

function PartnerSlider({ partners = [] }) {
  const slidesToRender = partners.length > 0 ? partners.map(p => ({
    id: p.partners_id,
    image: p.partners_image,
    link: '#'
  })) : images;
  return (
    <div className='partnerslide_sec'>
      <div className="container-fluid">
        <div className="section_heading  row text-center">
          <div className="content_part col-lg-12 col-sm-12 col-12">
            <h3>
              Our <span>Trusted</span> Partners
            </h3>
            <p>
              Compassionate nursing care, physiotherapy, and bedside assistance
              tailored for patient comfort, recovery, and daily healthcare
              support.
            </p>
          </div>
        </div>

       <div className="slider-wrapper">
          <Swiper
            modules={[Autoplay, Navigation]}
            spaceBetween={30}
            slidesPerView={4}
            loop={true}
            autoplay={{ delay: 1000, disableOnInteraction: false }}
            navigation
            pagination={{ clickable: true }}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 5,
              },
              480: {
                slidesPerView: 1,
                spaceBetween: 5,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 15,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 15,
              },
            }}
          >
            {images.map((item) => (
              <SwiperSlide key={item.id}>
                <Link to={item.link}>
                  <div className="partner_image">
                    <img
                      src={item.image}
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      
    </div>
  )
}

export default PartnerSlider;
